import React from 'react';

export default function PaperViolations() {
  return <div className="Paper_Violations">Test content for Paper Violations page</div>;
}
